var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "ex-tab-list" },
    [
      _c(
        "li",
        {
          staticClass: "ex-tab __pointer",
          class: { active: _vm.isShowFavorite },
          on: { click: _vm.showFavorite }
        },
        [
          _c("span", {
            staticClass: "favorite-icon __pointer",
            class: { active: _vm.isShowFavorite }
          })
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.quoteTokenCategory, function(c, i) {
        return _c(
          "li",
          {
            key: i,
            staticClass: "ex-tab __pointer",
            class: {
              active: !_vm.isShowFavorite && c === _vm.curentCategory,
              "active-side":
                (_vm.isShowFavorite && i === 0) ||
                _vm.quoteTokenCategory[i - 1] === _vm.curentCategory
            },
            on: {
              click: function($event) {
                return _vm.changeCategory(c)
              }
            }
          },
          [_c("span", [_vm._v(_vm._s(c))])]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }